export default {
  apply: {
    congrat_1_steps: '1. Scansiona il codice QR dalla fotocamera del tuo smartphone',
    congrat_2_steps: "2. Scarica l'app e completa il tuo profilo",
    congrat_3_steps: '3. Resta aggiornato sulle offerte vicino a te!',
    download_app: 'Scarica',
    form_address_label: 'Indirizzo',
    form_address_placeholder: 'Via Archimede, 22, 20129 Milano MI',
    form_email_label: 'E-mail',
    form_email_placeholder: 'johndoe@iziwork.com',
    form_firstname_label: 'Nome',
    form_firstname_placeholder: 'Ludovica',
    form_lastname_label: 'Cognome',
    form_lastname_placeholder: 'Rossi',
    form_phone_label: 'Telefono',
    form_phone_placeholder: '+39 340 636 3636',
    form_resume_button: 'Importare',
    form_resume_label: 'CV',
    message_info_accept_tcu: 'Continuando, accetti i',
    tcu_confidentiality: 'Termini di servizio',
    message_info_accept_conditions: ". Puoi visionare l'informativa sulla privacy ",
    tcu_conditions: 'qui',
    modal_action_apply: 'Candidati',
    modal_action_close: 'Chiudi',
    step_unknown: {
      dropzone: {
        drop: 'Trascina e rilascia o ',
        select: 'seleziona il tuo file',
        supported_files: 'File supportati: PDF, DOC, DOCX',
      },
    },
    subtitle_download_app: 'Scarica la nostra app per monitorare la tua candidatura.',
    subtitle_email_to_identify: 'La tua email ci consente di identificare se ci conosciamo già.',
    subtitle_resume_to_apply: 'Abbiamo bisogno del tuo CV e dei dettagli di contatto per elaborare la tua candidatura.',
    title_free_apply: 'Candidarsi per una missione',
    title_job_offer_apply: 'Candidati per questa offerta lavorativa',
    title_congratulation: 'Ben fatto, la tua candidatura è stata inviata!',
    title_you_are_new: 'Non ci conosciamo ancora!',
  },
  free_application_card: {
    button: 'Andiamo',
    message: 'Invia il tuo CV e ti contatteremo non appena troveremo un lavoro adatto a te.',
    title: 'Cerchi lavoro?',
  },
  banner: {
    join_community: 'Unisciti alla community',
    large_choice: 'Ampia varietà di offerte',
    large_choice_desc:
      "Seleziona il lavoro che preferisci da un'ampia varietà di offerte vicino a te (in somministrazione, tempo determinato e indeterminato)",
    personal_service: 'Supporto tempestivo e personalizzato',
    personal_service_desc:
      'Ricevi quotidianamente il supporto di cui hai bisogno grazie al team di assistenza. Più lavori con iziwork, più vantaggi ottieni!',
    simple_and_fast: 'Semplice e veloce',
    simple_and_fast_desc:
      "Aggiorna il tuo cv direttamente nell'app di iziwork e candidati alle offerte che ti interessano in soli 3 click",
  },
  browse_page: {
    heading: 'Scopri tutte le nostre offerte vicino a:',
    title: 'I nostri lavori intorno a te',
  },
  consent_manager: {
    content:
      'Utilizziamo le informazioni raccolte dai cookie per migliorare la tua esperienza di navigazione e consentirti di visualizzare annunci personalizzati e aumentare le prestazioni del nostro sito.',
    title: 'Gestisci le mie preferenze',
  },
  currencies: {
    EUR: '€',
    USD: '$',
  },
  date: {
    today: 'oggi',
  },
  error_pages: {
    internal_server_error_title: 'Spiacente, si è verificato un errore ...',
    not_found_subtitle1: 'Ma non preoccuparti, i nostri sviluppatori ci stanno lavorando!',
    not_found_subtitle2: 'Torna alla Home Page finchè il problema non è risolto',
    not_found_title: 'Oops, sembra che la pagina che stavi visualizzando sia scomparsa.',
    redirect_label: 'Tornare nella Home Page',
  },
  field_errors: {
    address_valueIncomplete: "L'indirizzo è incompleto",
    address_valueMissing: "L'indirizzo è obbligatorio",
    captcha_valueMissing: 'Il campo è obbligatorio',
    email_typeMismatch: "L'email non è corretta",
    email_valueMissing: 'E-mail è obbligatoria',
    firstname_valueMissing: 'Il nome è obbligatorio',
    lastname_valueMissing: 'Il cognome è obbligatorio',
    phone_typeMismatch: 'Il telefono non è corretto',
    phone_valueMissing: 'Il telefono è obbligatorio',
    resume_invalidSize: 'La dimensione del file deve essere compresa tra 1 KB e 10 MB',
    resume_invalidType: 'Il tipo di file non è valido',
    resume_valueMissing: 'Il CV è obbligatorio',
  },
  footer: {
    aboutUs: 'Chi siamo',
    account: 'Accedi',
    askADemo: 'Richiedi una demo',
    blog: 'Blog',
    browse: 'Visualizza le offerte',
    companies: 'Aziende',
    companySpace: 'Spazio commerciale',
    confidentiality: 'Politica sulla riservatezza',
    cookies_policy: 'Politica sui cookie',
    cookies_settings: 'Impostazioni dei cookie',
    join: 'Unisciti a noi',
    legalMentions: 'Avviso legale',
    partners: 'Partner',
    personalData: 'Dati personali',
    press: 'Area stampa',
    program: 'Programma partner',
    socialMedia: {
      facebook: 'Seguici su Facebook',
      instagram: 'Guarda le nostre storie su Instagram',
      linkedin: 'Aggiungici su LinkedIn',
      twitter: 'Guarda le nostre storie su Twitter',
    },
    usageConditions: 'Termini di utilizzo',
    who: 'Chi siamo?',
    why: 'Perché Iziwork?',
    worker: 'Lavoratori',
  },
  form_errors: {
    address: 'Seleziona una città',
    job: 'Inserisci un lavoro',
  },
  form_labels: {
    address: 'Città',
    distance: '< {{distance}} km',
    experience: 'Esperienza richiesta',
    job: 'Lavoro',
    sort: 'Ordina per',
    type: 'Tipo di contratto',
  },
  form_option_labels: {
    experience: {
      all: 'Tutte',
      any: 'Almeno 1 giorno',
      five_years: 'Più di 5 anni',
      none: 'Nessuna esperienza richiesta',
      one_month: 'Almeno 1 mese',
      one_year: 'Almeno 1 anno',
      six_months: 'Almeno 6 mesi',
      three_months: 'Almeno 3 mesi',
      two_years: 'Tra 2 e 5 anni',
    },
    sort: {
      publication: 'Data di pubblicazione',
      relevance: 'Rilevanza',
    },
    type: {
      all: 'Tutti',
      contract: 'Tempo determinato',
      non_seasonal_temporary: 'Somministrazione',
      permanent: 'Tempo indeterminato',
      seasonal_temporary: 'Somministrazione',
      temporary: 'Somministrazione',
    },
    urgent: 'Urgente',
  },
  form_option_values: {
    experience: {
      any: 'primo',
      five_years: '5 anni e oltre',
      none: 'nessuno',
      one_month: '1 mese',
      one_year: '1 anno',
      six_months: '6 mesi',
      three_months: '3 mesi',
      two_years: '2 anni e oltre',
    },
    sort: {
      publication: 'pubblicazione',
      relevance: 'rilevanza',
    },
    type: {
      contract: 'determinato',
      non_seasonal_temporary: 'somministrazione',
      permanent: 'indeterminato',
      seasonal_temporary: 'somministrazione',
      temporary: 'somministrazione',
    },
  },
  form_placeholders: {
    address: 'Cerca una città',
    job: 'Cerca un lavoro',
  },
  form_title: 'La tua ricerca',
  header: {
    findMission: 'Trova lavoro',
    myApply: 'Le mie candidature',
    partners: 'Recensioni aziendali',
  },
  languages: {
    dev: 'dev',
    en: 'inglese',
    fr: 'Francese',
    it: 'Italiano',
  },
  'meta-description': {
    jobOffer: {
      suffix: 'Candidati in 3 clic ora, lavora domani!',
      type: {
        contract: "Dai un'occhiata a questa offerta in Tempo Determinato come {{title}} a {{city}}.",
        permanent: "Dai un'occhiata a questa offerta in Tempo Indeterminato come {{title}} a {{city}}.",
        temporary: "Dai un'occhiata a questa offerta in Somministrazione come {{title}} a {{city}}.",
      },
    },
  },
  'meta-social-description': {
    mission_description:
      "Dai un'occhiata alla nostra offerta da {{displayName}} vicino a {{city}} . Candidati in 3 clic ora, lavora domani!",
    mission_title: '{{displayName}} - {{city}} ( {{areaCode}} ) - Offerta di lavoro',
    partner_description: 'Decine di offerte vicino a {{city}} ! Applicazione facile e veloce.',
    partner_title: 'Le nostre offerte di lavoro vicino a {{city}} ( {{areaCode}} )',
  },
  missions: {
    about: 'Descrizione mansione',
    apply: 'Candidati',
    back: 'Torna alla ricerca',
    bonuses: 'Benefits',
    certificates: 'Certificati',
    close_distance: 'vicino',
    contractType: 'Tipo di contratto',
    details_tab_label: 'Dettagli',
    distance: '{{distance}} km di distanza',
    experience: 'Esperienza',
    informations: 'Dettagli',
    location: 'Luogo',
    no_certificates_required: 'Nessun certificato richiesto',
    no_experience_required: 'Nessuna esperienza richiesta - giovani, lavoratori non qualificati .. accettati',
    outdated: {
      oops_text: 'questìa offerta non esiste più.',
      subtitle: "Scarica l'app per accedere a tutte le offerte di iziwork",
    },
    profile: 'Prerequisiti',
    published: 'Pubblicato ',
    remuneration: 'Retribuzione',
    see_all_missions: 'Vedi tutte le sue offerte',
    weekly_hours: {
      default: '{{hours}} ore settimanali',
      hours: '{{hours}} ore',
      per_week: 'settimanali',
    },
    workTime: 'Tempo di lavoro',
  },
  no_mission_modal: {
    button: {
      close: 'Chiudi',
      next: 'Avanti',
    },
    download_app: "Scarica subito l'app iziwork!",
    download_app_subtitle: 'Registrati e completa il tuo profilo in 5 minuti grazie al nostro sistema di analisi CV.',
    placeholder: {
      email: 'Il tuo indirizzo email',
      phone: 'Il tuo numero di telefono',
    },
    step: 'Passo {{step}} / 2',
    subtitle:
      'Siamo costantemente alla ricerca delle migliori opportunità per te! Inserisci i tuoi dati e ti informeremo non appena avremo offerte da proporti:',
    success: {
      body: 'Registrati e completa il tuo profilo in 5 minuti utilizzando il nostro sistema di analisi CV.',
      subtitle: 'Ci sei quasi!',
      title: 'Scopri le nostre offerte nella nostra applicazione',
    },
    title: 'Spiacente, sembra che non sia stata trovata alcuna offerta!',
  },
  no_missions_result: {
    download_app: "Scarica subito l'app iziwork!",
    subtitle:
      "Siamo costantemente alla ricerca delle migliori opportunità per te! Scarica l'applicazione e ti informeremo non appena avremo offerte da offrirti.",
    title: 'Spiacente, sembra che non siano state trovate offerte!',
  },
  salary: {
    gross_per_unit: {
      hourly: 'lordi/ora',
      monthly: 'lordi/mese',
      yearly: 'lordi/anno',
    },
  },
  search_params: {
    address: 'citta',
    distance: 'distanza',
    experience: 'esperienza',
    job: 'lavoro',
    page: 'pagina',
    sort: 'ordina',
    type: 'contratto',
  },
  tags: {
    experience: {
      any: 'Almeno 1 giorno',
      five_years: 'Più di 5 anni di esperienza',
      none: 'Nessuna esperienza richiesta',
      one_month: 'Almeno 1 mese di esperienza',
      one_year: 'Almeno 1 anno di esperienza',
      six_months: 'Almeno 6 mesi di esperienza',
      three_months: 'Almeno 3 mesi di esperienza',
      two_years: 'Tra 2 e 5 anni di esperienza',
    },
  },
  title: {
    '404_error': 'Pagina non trovata - offerte di lavoro iziwork',
    '500_error': 'Errore sconosciuto - offerte di lavoro iziwork',
    mission_page: 'Offerte di lavoro Iziwork',
    partner_page: 'Offerte di lavoro',
  },
  toasts: {
    application_error_body: 'La tua candidatura non è stata presa in considerazione, riprova più tardi.',
    application_error_title: "C'è stato un errore",
  },
  url: {
    askADemo: 'assunzioni-interim',
    blog: 'il-nostro-blog',
    companySpace: 'aziende',
    confidentiality: 'informativa-sulla-privacy',
    cookie: 'politique-des-cookies',
    legalMentions: 'note-legali',
    partners: 'partners',
    personalData: 'modulo-per-i-diritti-di-esercizio',
    press: 'stampa',
    usageConditions: 'condizioni-generali-utilizzo',
    who: 'chi-siamo',
    why: 'perche-iziwork',
  },
  welcome: 'Benvenuto',
  welcome_page: {
    meta_description: 'Trova le nostre offerte vicino a te e candidati in pochi clic',
    meta_social_description: 'Offerte di lavoro vicino a te! Applicazione facile e veloce.',
    meta_social_description_city: 'Offerte vicino a {{city}} ! Applicazione facile e veloce.',
    meta_social_title: 'Accedi alle nostre offerte di lavoro intorno a te',
    meta_social_title_city: 'Le nostre offerte di lavoro vicino a {{city}}',
    'meta_social_title_city&zipcode': 'Le nostre offerte di lavoro vicino a {{city}} ( {{zipcode}} )',
    meta_title: 'Le nostre offerte di lavoro - iziwork',
    meta_title_city: '{{city}} - Le nostre offerte di lavoro - iziwork',
    'meta_title_city&zipcode': '{{city}} ( {{zipcode}} ) - Le nostre offerte di lavoro - iziwork',
    missions_available_0: 'Nessuna offerta disponibile',
    missions_available_1: '1 offerta di lavoro trovata',
    missions_available_other: '{{count}} offerte di lavoro trovate',
    title_at_your_place: 'a te!',
    title_our_offers_near: 'Le nostre\n offerte vicino',
  },
};
